module.exports = __webpack_public_path__ + "img/6.85e66e57.png";